export default "__VITE_ASSET__ByTUzKtn__"